import { render, staticRenderFns } from "./ArticlesItemView.vue?vue&type=template&id=1157fe3a&scoped=true&"
import script from "./ArticlesItemView.vue?vue&type=script&lang=js&"
export * from "./ArticlesItemView.vue?vue&type=script&lang=js&"
import style0 from "./ArticlesItemView.vue?vue&type=style&index=0&id=1157fe3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1157fe3a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCol,VContainer,VIcon,VRow,VSheet})
